exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox[data-v-10973785]{margin-right:30px}.checkbox>span[data-v-10973785]{position:absolute;z-index:2;margin-left:3px}", ""]);

// exports
